
export const PrimaryColor = "#FCB131";
export const SecondaryColor = "#373E44";
export const TertiaryColor = "#3F515B";
export const BackgroundColor = "#F7F7F9";
export const SecondaryBackgroundColor = "#DCDCDE";
export const OffColor = "#84888C";

export const BorderColor = "#B7BBBE";